
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dictionary",
      function () {
        return require("private-next-pages/dictionary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dictionary"])
      });
    }
  